<template>
	<div class="container">
		<div class="w100 ub ub-pe ub-ac">
			<div class="ub ub-ac sort-wrap ub-pj px-1">
				<span :class="[auditStatus==-1&&postStatus==1?'active':'']" @click="toChangeSort(-1)">全部</span>
				<span :class="[auditStatus==0&&postStatus==1?'active':'']" @click="toChangeSort(0)">审核中</span>
				<span :class="[auditStatus==1&&postStatus==1?'active':'']" @click="toChangeSort(1)">已通过</span>
				<span :class="[auditStatus==2&&postStatus==1?'active':'']" @click="toChangeSort(2)">未通过</span>
				<span :class="[postStatus==0?'active':'']" @click="toChangePublic(0)">草稿</span>
			</div>
		</div>
		<el-tabs class="tabs" v-model="activeTab" @tab-click="handleClick">
			<el-tab-pane label="文章" name="article">
				<div v-if="dataList.length>0">
					<div v-for="(item,index) in dataList" :key="index">
						<PublicItem :item="item" :activeTab="activeTab" @toDelete="toDelete"/>
					</div>
				</div>
				<Empty v-else content="暂无数据"/>
			</el-tab-pane>
			<el-tab-pane label="视频" name="video">
				<div v-if="dataList.length>0">
					<div v-for="(item,index) in dataList" :key="index">
						<PublicItem :item="item" :activeTab="activeTab" @toDelete="toDelete"/>
					</div>
				</div>
				<Empty v-else content="暂无数据"/>
			</el-tab-pane>
			<el-tab-pane label="动态" name="trends">
				<div v-if="dataList.length>0">
					<div v-for="(item,index) in dataList" :key="index">
						<PublicItem :isAsync="true" :item="item" :activeTab="activeTab" @toDelete="toDelete"/>
					</div>
				</div>
				<Empty v-else content="暂无数据"/>
			</el-tab-pane>
		</el-tabs>
		<div v-if="total>pageSize">
			<Pagination :pageSize="pageSize" :pageNum="pageNum" :total="total" @pageChange="pageChange"/>
		</div>
	</div>
</template>

<script>
	import Pagination from '@/components/pagination'
	import Empty from '@/components/empty'
	import PublicItem from '@/components/public/publicItem'
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'publicManage',
		components: {
			PublicItem,
			Empty,
			Pagination
		},
		data(){
			return{
				activeTab: 'article',
				auditStatus: -1, //-1 全部 0未审核 1已通过 2未通过  默认已通过
				postType: 0,  //0文字  1图片 2视频
				postStatus: 1, //默认是发布  0草稿  1发布
				pageNum: 1,
				pageSize: 30,
				dataList: [],
				total: 0
			}
		},
		created(){
			this.userId = localStorage.getItem('userId')||''
			this.getDataList()
		},
		methods: {
			//获取发布帖子
			async getDataList(){
				let param = {
					userId: this.userId,
					addUserId: this.userId,
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					auditStatus: this.auditStatus,
					// postType: this.postType,
					postStatus: this.postStatus
				}
				ajaxParam(param)
				const res = await post('v1/circle/userPostList', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
			toChangeSort(num){
				console.log(num)
				this.auditStatus = num
				this.postStatus = 1
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			toChangePublic(num){
				this.postStatus = num
				this.auditStatus ='-1'
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			pageChange(e){
				this.dataList = []
				this.pageNum = e.number
				this.getDataList()
			},
			handleClick(tab, event) {
				console.log(tab.name)
				let name = tab.name
				if(tab.name == 'article') {
					this.postType = 0
				} else if(tab.name == 'video'){
					this.postType = 2
				} else{
					this.postType = 1
				}
				this.dataList = []
				this.pageNum = 1
				this.getDataList()
			},
			//删除帖子
			toDelete(e){
				let id = e.postId
				this.$confirm('确定要删除该帖子吗？','温馨提示',{
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				}).then(async()=>{
				    let param = {
				    	userId: this.userId,
				    	postId: id
				    }
				    ajaxParam(param)
				    const res = await post('v1/circle/deletePost', qs.stringify(param))
				    if(res.data.code==200){
				    	this.$message.success('删除成功！')
						this.dataList.forEach((item,index)=>{
							if(item.id==id){
								this.dataList.splice(index,1)
							}
						})
				    } else {
				    	this.$message.error(res.data.msg)
				    }
				}).catch(()=>{
				
				})
				
			}
		}
	}
</script>

<style lang="less" scoped>
	.container{
		position: relative;
		.sort-wrap{
			position: absolute;
			right: 40px;
			top: 0;
			width: 260px;
			height: 32px;
			background: #F3F4F7;
			border-radius: 4px;
			z-index: 999;
			span{
				display: block;
				height: 28px;
				padding: 0 5px;
				border-radius: 4px;
				text-align: center;
				line-height: 28px;
				cursor: pointer;
				font-size: 12px;
			}
			span.active{
				background: #fff;
			}
		}
		.empty{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 260px;
			margin: 60px auto;
			img{
				width: 260px;
				height: 230px;
			}
			span{
				padding: 20px 0 30px;
				color: var(--color-text-opacity);
			}
			.public-btn{
				display: block;
				width: 88px;
				height: 34px;
				background: #CF171D;
				border-radius: 16px;
				line-height: 34px;
				text-align: center;
				color: #fff;
			}
		}
		/deep/ .el-tabs__item{
			height: 42px;
			line-height: 42px;
		}
	}
</style>
